module.exports = __webpack_public_path__ + "9408e6924b5f440610a071e119c64ce4.svg";